import React, { useState } from "react";
import { Bubble, BubbleProps } from "tea-component";
import SvgIcon from "@/pages/home/components/SvgIcon";
import { TOptionsItem } from "../types";

const OptionItemInfo = (props: { infoItem: TOptionsItem; bubbleProps?: BubbleProps; }) => {
  const { infoItem, bubbleProps } = props || {};
  const [isHover, setIsHover] = useState(false);

  return (infoItem?.info ? <div
    className="db-option-info"
    onMouseOver={() => {
      setIsHover(true);
    }}
    onMouseOut={() => {
      setIsHover(false);
    }}
  >
    <Bubble
      trigger="hover"
      arrowPointAtCenter
      placement="top-start"
      content={infoItem?.info}
      dark
      {...(bubbleProps || {})}
    >
      <i>
        <SvgIcon
          className="db-option-info-icon"
          type={isHover ? 'alert-circle-action' : 'alert-circle-m'}
        />
      </i>
    </Bubble>
  </div> : '');
};

export default OptionItemInfo;